export const DEV_USER_SID_KEY = 'dev-user-sid';
export const OWN_USER_VALUE = 'NONE';
/** The backend's own system account; it is not meant to be logged in as. */
export const SYSTEM_USER_SID = 'S-1-0-0';
/** The backend's maximum page size, so a single request returns every user. */
export const ALL_USERS_PAGE_SIZE = 500;

export interface SimulatorUser {
  name: string;
  securityIdentifier: string;
  isActive: boolean;
}

export interface SimulatorOption {
  label: string;
  value: string;
}

export function toSimulatorOptions(users: SimulatorUser[]): SimulatorOption[] {
  const selectable = users.filter(
    (user) => user.securityIdentifier !== SYSTEM_USER_SID,
  );
  return [
    { label: 'Eigener Nutzer', value: OWN_USER_VALUE },
    ...selectable
      .filter((user) => user.isActive)
      .map((user) => ({ label: user.name, value: user.securityIdentifier })),
    ...selectable
      .filter((user) => !user.isActive)
      .map((user) => ({
        label: `${user.name} (inaktiv)`,
        value: user.securityIdentifier,
      })),
  ];
}

export function readDevUserSid(storage: Storage = sessionStorage): string {
  return storage.getItem(DEV_USER_SID_KEY) ?? OWN_USER_VALUE;
}

/**
 * Stores the simulated user and reloads the page, so no query, cache entry or
 * component state survives from the previous user.
 */
export function switchDevUser(
  sid: string,
  storage: Storage = sessionStorage,
  reload: () => void = () => window.location.reload(),
): void {
  if (sid === OWN_USER_VALUE) {
    storage.removeItem(DEV_USER_SID_KEY);
  } else {
    storage.setItem(DEV_USER_SID_KEY, sid);
  }
  reload();
}
